import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, openLoginModal } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (!loading && !isAuthenticated) {
      // Open login modal with current path as redirect destination
      // openLoginModal(location.pathname + location.search);
      navigate('/login', { state: { from: location } });
    }
  }, [loading, isAuthenticated, location, openLoginModal]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Return empty div as the login modal will be shown
    return <div className="min-h-screen"></div>;
  }

  return children;
};

export default ProtectedRoute;
